"use client";

import {
  MenubarRadioGroup,
  MenubarRadioItem,
  MenubarSub,
  MenubarSubContent,
  MenubarSubTrigger,
  MapTile,
} from "@oreme/ui";
import { useAtom } from "jotai";
import { mapTileAtom } from "@/store";
import { mapTiles } from "@/utils";
import { ReactElement, useEffect } from "react";
import { useTranslations } from "next-intl";
import { useMapLibre } from "@/hooks";

function SharedMenubarViewTile() {
  const t = useTranslations("global.MenubarViewTile");
  const { map, projection } = useMapLibre();
  const [tile, setTile] = useAtom(mapTileAtom);

  useEffect(() => {
    if (map) {
      map.on("style.load", () => {
        map.setProjection({
          type: projection.id,
        });
      });
    }
  }, [map, projection]);

  const handleVelueChange = (value: string): void => {
    const newTile = mapTiles.get(value) as MapTile;
    setTile(newTile);
  };

  return (
    <MenubarSub>
      <MenubarSubTrigger>{t("title")}</MenubarSubTrigger>
      <MenubarSubContent>
        <MenubarRadioGroup value={tile.id} onValueChange={handleVelueChange}>
          {Array.from(mapTiles).map(([key, tile]): ReactElement => {
            return (
              <MenubarRadioItem key={key} value={tile.id}>
                {tile.title}
              </MenubarRadioItem>
            );
          })}
        </MenubarRadioGroup>
      </MenubarSubContent>
    </MenubarSub>
  );
}

export { SharedMenubarViewTile };
